const empty = () => {}

const logStuff = typeof window !== 'undefined' ? (window as any).log === true || !!localStorage?.getItem('log') : true

export const debug = logStuff ? console.debug : empty
export const error = logStuff ? console.error : empty
export const info = logStuff ? console.info : empty
export const log = logStuff ? console.log : empty
export const warn = logStuff ? console.warn : empty
